import UserStyle from "./userStyle";
import AppColors from "./colors";
import color from "color";

class styleHelper {
    constructor() {}

    get userTabContainerStyle() {
        return {
            tabBarUnderlineStyle: {
                get backgroundColor() {
                    return UserStyle.secondary;
                },
            },
        };
    }

    get userTabBarStyle() {
        return {
            activeTabStyle: {
                get backgroundColor() {
                    return UserStyle.primary;
                },
            },
            tabStyle: {
                get backgroundColor() {
                    return UserStyle.primary;
                },
            },
            textStyle: {
                color: AppColors.textWhite75,
            },
            activeTextStyle: {
                color: AppColors.textWhite,
            },
        };
    }

    get userHeaderStyle() {
        return {
            get androidStatusBarColor() {
                return color(UserStyle.primary)
                    .darken(0.2)
                    .hex();
            },
            get backgroundColor() {
                return UserStyle.primary;
            },
            style: {
                get backgroundColor() {
                    return UserStyle.primary;
                },
            },
        };
    }

    get userHeaderStyleBgImg() {
        return {
            get androidStatusBarColor() {
                return color(UserStyle.primary)
                    .darken(0.2)
                    .hex();
            },
            /*backgroundColor: UserStyle.primary,
            style: {
                backgroundColor: UserStyle.primary,
            }*/
        };
    }
}

const StyleHelper = new styleHelper();

export default StyleHelper;
